'use strict';
angular.module('schoolLinqApp').directive('contentHeader', function () {
	return {
		scope: { section: '@', sectiontitle: '@', sectionicon: '@', hidependo: '@' },
		restrict: 'E',
		template: require('@ajs/templates/contentHeader.html'),
		link: function (scope, iElement, iAttrs) {},
		controller: [
			'$scope',
			'$element',
			'authService',
			'$location',
			'USER_CLAIMS',
			function ($scope, $element, authService, $location, USER_CLAIMS) {
				var container = $('div[id="container"]');
				container.removeClass('container');
				container.addClass('container-fluid');

				$scope.username = authService.authentication.userName;
				$scope.unit = authService.authentication.unitId;
				$scope.accessSystem = authService.authentication.userRoles.indexOf(USER_CLAIMS.system) > -1;
				$scope.accessSA = authService.authentication.userRoles.indexOf(USER_CLAIMS.lsb) > -1;

				// NO LONGER NEEDED -  all routes in School Bookkeeping are prefixed with lsb.
				// // Don't show the Pendo icon on School Accounting pages.  Added here because SA pages share same code as FM pages
				// if ($location.path().startsWith('/sa/')) {
				// 	$scope.hidependo = true;
				// }
			},
		],
	};
});
